module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_4.2fd6a73d.jpg";